import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

import Chip from '@material-ui/core/Chip'
import Products from 'components/account/Products'

import stripeActions from 'store/modules/stripe'

const useStyles = makeStyles(theme => ({
  actions: {
    width: '100%',
    textAlign: 'right',
  },
  badge: {
    textAlign: 'right',
  },
  selectedText: {
    color: theme.palette.secondary.main,
  }
}))

const WebsitePayment = ({
  website,
}) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const paymentProduct = website ? website.product : null

  const currentLevel = paymentProduct ?
    parseInt(paymentProduct.metadata.level) :
    0

  const onChangePaymentLevel = useCallback((product) => {
    dispatch(stripeActions.changeWebsitePlan({
      website: website.id,
      product: product.id,
      price: product.price.id,
    }))
  }, [
    website,
  ])

  return (
    <Products
      getFeatures={({
        product,
      }) => {
        return paymentProduct && product.metadata.nocodeId == paymentProduct.metadata.nocodeId ?
          Object
            .keys(website.features)
            .reduce((all, key) => {
              all[key] = website.features[key].value
              return all
            }, {}) :
            product.metadata
      }}
      getCardTheme={({
        product,
      }) => {
        const isActive = paymentProduct && product.metadata.nocodeId == paymentProduct.metadata.nocodeId
        return isActive ? {
          title: classes.selectedText,
        } : {}
      }}
      getActions={({
        product,
      }) => {
        const isActive = paymentProduct && product.metadata.nocodeId == paymentProduct.metadata.nocodeId
        const productLevel = parseInt(product.metadata.level)

        const activateTitle = productLevel > currentLevel ?
          'Upgrade' :
          'Downgrade'

        const activateVariant = productLevel > currentLevel ?
          'contained' :
          'outlined'

        const activateColor = productLevel > currentLevel ?
          'secondary' :
          'default'
          
        const content = isActive ? (
          <div className={ classes.badge }>
            <Chip
              label="ACTIVE"
              color="secondary"
              variant="outlined"
            />
          </div>
        ) : (
          <Button
            size="small"
            color={ activateColor }
            variant={ activateVariant }
            onClick={ () => onChangePaymentLevel(product) }
          >
            { activateTitle }
          </Button>
        )

        return (
          <div className={ classes.actions }>
            { content }
          </div>
        )
      }}
    />
  )
}

export default WebsitePayment